@if (pointsEarnedChangeIndicator?.value !== undefined &&
pointsEarnedChangeIndicator?.value !== null) {
<mat-chip class="kpi-chip-points-earned mat-standard-chip">
  {{ pointsEarnedChangeIndicator?.value }}
</mat-chip>
} @if (pointsRedeemedChangeIndicator?.value !== undefined &&
pointsRedeemedChangeIndicator?.value !== null) {
<mat-chip class="kpi-chip-points-redeemed mat-standard-chip">
  {{ pointsRedeemedChangeIndicator?.value }}
</mat-chip>
}
